export default {
      id: "investment-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#investment",
      toString: function () {
        return this.url;
      }
    }